import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FirmDetailsComponent } from '@shared/components/firm-details/firm-details.component';

@Component({
  selector: 'app-firm-details-page',
  templateUrl: 'firm-details-page.component.html',
  styleUrls: ['firm-details-page.component.scss'],
  imports: [FirmDetailsComponent],
})
export class FirmDetailsPageComponent {
  public readonly location = inject(Location);
  public readonly router = inject(Router);
}
